import { onApiError } from "../error";
import { get } from "./client";

/**
 * @param {("farmcamsim"|"fencealarm"|"fencealarm2"|"smartplug"|"smartplug2"|"user")} key
 * @param {string} value
 * @returns {Promise<User>}
 */
async function impersonate(key, value) {
	const res = await get(`/admin/impersonate?key=${key}&value=${value}`);

	if (!res.ok) throw await onApiError(res);
	return await res.json();
}

export { impersonate };
